import React, {Component} from 'react'
import {Form, Select} from 'antd';
import PropTypes from 'prop-types';
import {deepCompare} from '../../utills/common'

//无状态组件
function SelectBoxFormItem(props) {
    let options = [];
    if (props.data != null) {
        props.data.forEach(
            d => {
                options.push(<Select.Option key={d.id}
                                            value={d.content}>{d.content }</Select.Option>)
            })
        /*  state.origin.map(d => <Option key={d.cityId}
         value={d.cityName}>{d.countryName + ' ' + d.cityName}</Option>);*/

    }
    return <Form.Item label={props.label}>
        {props.getFieldDecorator(props.name, {
            initialValue: props.initialValue,
            //rules: [{required: true, message: '该项必填'}]
        })(<Select onChange={props.handleChange}
                   getPopupContainer={triggerNode => triggerNode.parentNode}
                   disabled={props.disabledOpt} allowClear={true}
                   showSearch
                   optionFilterProp="children"
                   filterOption={(input, option) => option.props.children.includes(input)}
                   >
            {options}
        </Select>)}
    </Form.Item>
}
/*
 SelectAreaFormItem.propTypes = {
 operation: PropTypes.func,
 disabledOpt: PropTypes.bool,
 options: PropTypes.array,
 realValue: PropTypes.string,
 };
 const areEqual = (prevprops, nextprops) => {
 /!** 与shouldComponentUpdate相似，但是这是用来判断prevprops和nextprops是否相等，相
 **  等返回true,组件不发生重新渲染；反之，组件重新渲染。主要用于性能优化，不要过于依
 **  赖，容易发生bug
 **!/
 const flag = prevprops.value === nextprops.value && deepCompare(prevprops.data, nextprops.data);
 return flag;
 }
 export default React.memo(SelectAreaFormItem, areEqual);*/
export default SelectBoxFormItem;

